<template>
  <div class="modal-overlay" >
    <div class="modal" @click.stop>
      <h2>Editar Nodo</h2>

      <!-- Campo de nombre del nodo -->
      <input v-model="node.name" placeholder="Nombre del Nodo" />

      <!-- Selector de color con opciones predefinidas -->
       <label for="">Color del Nodo:</label>
      <select v-model="node.color">
        <option value="#d41b1b">Rojo</option>
        <option value="#008000">Verde</option>
        <option value="#3949ab">Azul</option>
        <option value="#F3FF33">Amarillo</option>
        <option value="#572364">Morado</option>
        <option value="#ff8000">Naranja</option>
      </select>

      <!-- Otros campos -->
      <input v-model="node.encargado" placeholder="Encargado" />
      <input v-model="node.clasificacion" placeholder="Clasificación" />

      <!-- Campo para subir archivo de imagen -->
      <input type="file" @change="handleFileUpload" />
      <div v-if="imagePreview" class="image-preview">
        <img :src="imagePreview" alt="Vista previa de la imagen" />
      </div>

      <div class="modal-actions">
        <button @click="save">Guardar</button>
        <button @click="$emit('cancel')">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    node: {
      type: Object,
      required: true,
      default: () => ({
        name: '',
        color: '#FF5733', // Valor predeterminado
        encargado: '',
        clasificacion: ''
      })
    }
  },
  data () {
    return {
      imagePreview: null // Para la vista previa de la imagen
    }
  },
  methods: {
    handleFileUpload (event) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.imagePreview = e.target.result
          this.node.image = file
        }
        reader.readAsDataURL(file)
      }
    },
    save () {
      this.$emit('save', this.node)
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  width: 400px;
}

input, select {
  width: 100%;
  margin: 10px 0;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.image-preview {
  margin-top: 10px;
}

.image-preview img {
  max-width: 100%;
  max-height: 200px;
  display: block;
  border-radius: 5px;
  margin-top: 10px;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

button {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 15px;
  cursor: pointer;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #0056b3;
}
</style>
